
document.addEventListener("DOMContentLoaded", (event) => {

	for (const node of document.querySelectorAll('[href="#modal"]')) {
		node.addEventListener('click', (event) => {
			const modal = document.querySelector('.page__modal');
			if (modal) {
				modal.classList.toggle('active');
			}
		});
	}
	for (const node of document.querySelectorAll('.page__modal .button--close')) {
		node.addEventListener('click', (event) => {
			for (const node of document.querySelectorAll('.page__modal.active')) {
				node.classList.remove('active');
			}
		});
	}

	document.addEventListener('keyup', (event) => {
		if (event.key === 'Escape') {
			for (const node of document.querySelectorAll('.page__modal.active')) {
				node.classList.remove('active');
			}
		}
	})

});
